<template>
  <div class="sg-content  common-max-width">
    <div class="sg-content-search common-max-width">
      <div
        class="sg-content-search-ipt"
        @click="searchFun()">
        <img
          class="sg-content-search-icon"
          src="../assets/images/home/search.png"/>
        <div class="sg-content-search-ipt-text">输入关键词查找资源</div>
      </div>
      <img
        class="sg-content-search-icon"
        src="../assets/images/home/ls_icon.png"
        @click="Refresh"/>
    </div>
    <div
      v-show="isShowAd"
      class="fl-nav">
      <div
        class="icon-box"
        @click="changeFun()">
        <van-icon
          :name="iconName"
          color="#fff" />
      </div>
      <div
        ref="navtag"
        :class="{'fl-nav-cell':tagbool,'van-tabs-box':!tagbool }" >
        <ul
          class="tag-view"
          :style="showTab" >
          <li
            v-for="(item, index) in tagsList"
            :ref="`navtag-${index}`"
            :key="index"
            class="tag-view-cell"
            :class="{ tagactive: tagIndex == index }"
            @click="tagChange(index)">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>

    <div
      v-show="slidersBool && isShowAd"
      :key="bannerindex"
      class="sg-content-banner">
      <banner
        :images="sliders"
        :swiperOption="swiperOption"></banner>
    </div>

    <div class="sg-content-items">
      <div
        v-for="(item, index) in itemList"
        :key="index"
        class="sg-content-item"
        @click="itemFun(index)">
        <base-image
          class="sg-content-item-img"
          :url="item.icobase64.url"
          :type="item.icobase64.type"
          :ratio="1"
          encrypt/>
        <p>{{ item.name }}</p>
      </div>
      <div
        class="sg-content-item"
        @click="itemFun(-1)">
        <base-image
          class="sg-content-item-img"
          :ratio="1"
          :url="require(`../assets/images/home/all.png`)">
        </base-image>
        <p>全部</p>
      </div>
    </div>
    <div class="sg-content-box">
      <div
        v-if="isShowAd && ggaoImg"
        class="sg-ggao-box" >
        <a
          :href="ggaoImg.url"
          target="_blank">
          <base-image
            fit="cover"
            :ratio="750/300"
            :url="ggaoImg.imgbase64.url"
            :type="ggaoImg.imgbase64.type"
            encrypt/>
        </a>
      </div>
      <div class="sg-home-content">
        <ul class="row">
          <li>
            <home-video-block
              :title="recommandData.title"
              :typeId="recommandData.typeId"
              :propsList="recommandList"
              showChangeBtn>
            </home-video-block>
          </li>
          <li
            v-for="(items, index) in videoList"
            :key="index">
            <template v-if="items.is_ad != 1">
              <home-video-block
                :title="items.name"
                :typeId="items.type_id"
                :propsList="items.list">
              </home-video-block>
            </template>
            <template v-else>
              <div
                v-show="isShowAd"
                class="row-cell-content">
                <a
                  :href="items.url"
                  target="_blank">
                  <base-image
                    :fit="`contain`"
                    :ratio="750/300"
                    :encrypt="true"
                    :url="items.imgbase64.url"
                    :type="items.imgbase64.type">
                  </base-image>
                </a>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </div>
    <tabbar></tabbar>
  </div>
</template>

<script>
import { selectItemList, videoList, bannerList, bannerTags, videoRecommand } from '@/API/home'
import banner from '@/components/banner'
import tabbar from '@/components/tabbar'
import homeVideoBlock from '@/components/homeVideoBlock'
import baseImage from '@/components/baseImage'
import { scrollLeftTo } from 'vant/lib/tabs/utils.js'
import { mapState } from 'vuex'

export default {
  name: 'home',
  components: {
    banner,
    tabbar,
    baseImage,
    homeVideoBlock
  },
  data () {
    return {
      gagaoUrl: require('../assets/images/home/750-300.png'),
      itemList: [],
      bannerindex: 0,
      videoList: [],
      sliders: [],
      recommandList: [],
      recommandData: {
        title: '精彩推荐',
        typeId: 0
      },
      slidersBool: false,
      ggaoImg: null,
      iconName: 'arrow-down',
      tagbool: true,
      tagIndex: 0,
      tagsList: [],
      list: [],
      loading: false,
      finished: false,
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        autoplay: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -80, // slide左右距离
          depth: 400, // slide前后距离
          modifier: 0.5, //
          slideShadows: false // 滑块遮罩层
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        }
      }
    }
  },
  computed: {
    ...mapState(['isShowAd']),
    showTab () {
      return { display: this.tagbool ? 'block' : 'inline-flex' }
    }
  },
  created () {
    this.getItemFun()
    this.getVideoList()
    // this.getBannerList();
    this.getBannerTags()
    this.getVideoRecommand()
    this.Width = window.screen.availWidth
  },

  methods: {
    // 刷新页面

    Refresh () {
      location.reload()
    },
    getBannerTags () {
      const _this = this
      bannerTags()
        .then((res) => {
          _this.tagsList = res.rescont
          localStorage.setItem('bannerType', res.rescont[0].id)
          _this.getBannerList()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getBannerList () {
      const _this = this
      _this.sliders = []
      bannerList()
        .then((res) => {
          if (res.rescont.length > 0) {
            _this.slidersBool = true
            for (let i = 0; i < res.rescont.length; i++) {
              _this.$set(_this.sliders, i, res.rescont[i])
            }
            this.bannerindex = this.sliders.length
          } else {
            _this.slidersBool = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getItemFun () {
      selectItemList()
        .then((res) => {
          this.itemList = res.rescont.slice(0, 7)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getVideoList () {
      videoList()
        .then((res) => {
          for (let i = 0; i < res.rescont.length; i++) {
            if (i === 0 && res.rescont[0].is_ad === 1) {
              this.ggaoImg = res.rescont[0]
            } else {
              this.videoList.push(res.rescont[i])
            }
          }
          // this.videoList = res.rescont;
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getVideoRecommand () {
      videoRecommand().then(res => {
        this.recommandList = res.rescont
      })
    },
    itemFun (index) {
      if (index === -1) {
        this.$router.push({
          path: '/list',
          query: {
            typeId: 0
          }
        })
      } else {
        this.$router.push({
          path: '/list',
          query: {
            typeId: this.itemList[index].id
          }
        })
      }
    },
    searchFun () {
      this.$router.push({ path: '/search' })
    },
    scrollIntoView (index) {
      const itemRef = this.$refs[`navtag-${index}`][0]
      const itemLeft = itemRef.offsetLeft
      const itemWidth = itemRef.offsetWidth
      const navTagWidth = this.$refs.navtag.offsetWidth
      const left = itemLeft - (navTagWidth - itemWidth) / 2
      scrollLeftTo(this.$refs.navtag, left, 0.3)
      this.tagIndex = index
      localStorage.setItem('bannerType', this.tagsList[this.tagIndex].id)
      this.getBannerList()
    },
    // 更多切换按钮
    changeFun () {
      if (this.iconName === 'arrow-up') {
        this.iconName = 'arrow-down'
        this.tagbool = true
      } else {
        this.iconName = 'arrow-up'
        this.tagbool = false
      }
    },
    // 更多Item点击事件
    tagChange (index) {
      this.tagIndex = index
      this.scrollIntoView(this.tagIndex)
    }
  }
}
</script>
<style scoped>
.fl-nav {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding-right: 40px;
  margin: 0 0 5px 0;
  overflow: hidden;
  border-bottom: 1px solid #333;
}

.fl-nav-cell {
  display: inline-block;
  display: flex;
  width: 100%;
  height: 45px;
  overflow-x: scroll;
  text-align: left;
  white-space: nowrap;
}

.fl-nav-cell::-webkit-scrollbar {
  height: 0;
}

.fl-nav-cell ul {
  box-sizing: border-box;
  margin: 0 0;
  list-style: none;
}

.fl-nav-cell ul li {
  position: relative;
  box-sizing: border-box;
  display: inline-block;
  min-width: 35px;
  padding: 0 15px;
  font-size: 14px;
  line-height: 44px;
  color: #fff;
  text-align: center;
}

.fl-nav-cell-box {
  box-sizing: border-box;
  width: 110px;
  height: 60px;
  padding: 10px 10px;
  text-align: left;
  border-radius: 2px;
}

.fl-nav-cell-box img {
  width: 18px;
  height: 18px;
}

.fl-nav-cell-box-p {
  height: 20px;
  margin: 0 0;
  overflow: hidden; /* 超出部分隱藏 */
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  text-overflow: ellipsis; /* 超出部分顯示省略號 */
  letter-spacing: 1px;
  white-space: nowrap; /* 規定段落中的文本不進行換行 */
}

.fl-nav-cell-box-row {
  display: inline-flex;
  width: 100%;
  height: 20px;
}

.fl-nav-cell-box-row-label {
  box-sizing: border-box;
  width: 72px;
  padding: 0 0 0 2px;
  overflow: hidden; /* 超出部分隱藏 */
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  text-overflow: ellipsis; /* 超出部分顯示省略號 */
  letter-spacing: 2px;
  white-space: nowrap; /* 規定段落中的文本不進行換行 */
}

.van-tabs-box {
  box-sizing: border-box;
  overflow-x: scroll;
  background-color: #000;
}

.van-tabs-box::-webkit-scrollbar {
  display: none;
}

.icon-box {
  position: absolute;
  top: 0;
  right: 0;
  box-sizing: border-box;
  width: 40px;
  height: 45px;
  padding: 11px 10px;
}

.tag-view {
  position: relative;
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: 45px;
}

.tag-collapse {
  flex-wrap: nowrap;
}

.tag-view .tag-view-cell {
  position: relative;
  box-sizing: border-box;
  min-width: 20%;
  max-width: 120px;
  height: 45px;
  padding: 0 5px;
  margin: 0 0;
  overflow: hidden;
  font-size: 14px;
  line-height: 45px;
  color: #fff;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tagactive {
  color: transparent !important;
  background: linear-gradient(to left bottom, #20e0ff, #54a8ff);
  -webkit-background-clip: text;
  background-clip: text;
}

.tagactive::after {
  position: absolute;
  bottom: 0;
  left: 50%;
  z-index: 99;
  width: 50%;
  height: 3px;
  content: "";
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(to left bottom, #20e0ff, #54a8ff);
  background:
    linear-gradient(
      270deg,
      rgba(84, 168, 255, 1),
      rgba(32, 224, 255, 1)
    );
  transform: translateX(-50%);
}

.sg-content {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding-top: 44px;
  padding-bottom: 10px;
  background-color: #000;
}

.sg-content-search {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  display: inline-flex;
  width: 100%;
  height: 44px;
  padding: 5px 15px;
  text-align: center;
  background-color: #000;
}

.sg-content-search-ipt {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  width: 100%;
  height: 34px;
  padding: 0 9px;
  font-size: 14px;
  line-height: 34px;
  color: #999;
  text-align: left;
  background-color: #282828;
  border-radius: 17px;
}

.sg-content-search-ipt-text {
  height: 34px;
  font-size: 14px;
  line-height: 34px;
  color: #999;
  text-align: left;
}

.sg-content-search-icon {
  box-sizing: border-box;
  width: 40px;
  height: 34px;
  padding: 7px 10px;
}

.sg-content-banner {
  position: relative;
  width: 100%;
}

.sg-content-items {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 10px 10px 5px 10px;
}

.sg-content-item {
  position: relative;
  width: 15%;
  margin: 0 5% 10px 5%;
}

.sg-content-item-img {
  border-radius: 8px;
}

.sg-content-item p {
  width: 100%;
  margin: 0 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}

.sg-content-box {
  position: relative;
  width: 100%;
}

.sg-ggao-box {
  width: 100%;
}

.sg-home-content {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 15px 15px;
}

.sg-home-content .row {
  position: relative;
  width: 100%;
  padding: 0 0;
  margin: 0 0;
  list-style: none;
}

</style>



// WEBPACK FOOTER //
// src/views/home.vue